export default __webpack_public_path__ + "static/media/star.4e800843.svg";